import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PersonImg from '../../assets/images/team1.jpg'

import { teamMembers } from '../companydata';
const TeamSection = () => {
  return (
    <section className="team py-10 bg-white">
      <div className="container">
        <div className="team-inner text-center">
          <div className="section-title mb-6">
            <h6 className="text-uppercase green fw-medium mb-1">Our Team</h6>
            <h2 className="fw-bold">
              Our experienced <span className="green">team</span> members
            </h2>
          </div>

          <div className="section-body">
            <div className="row gy-4 justify-content-center">
              {teamMembers.slice(0,3).map((member) => (
                <div key={member.id} className="col-lg-4 col-md-6">
                  <div className="team-box p-4 bg-white border border-2 border-lightgreen rounded-4 shadow-sm h-100 transition-hover">
                    {/* <div className="team-member-image mb-5">
                      <img
                        src={member.img}
                        alt="Strategic Technical Collaborator"
                        className="rounded-circle object-fit-cover"
                        style={{ width: '150px', height: '150px' }} // Added fixed dimensions for a perfect circle
                      />
                    </div> */}
                    <div className="team-member-info mb-3">
                      <h5 className="mb-2 fw-bold">
                        <Link to="/team-detail" className="text-dark text-decoration-none">
                          {member.name}
                        </Link>
                      </h5>
                      <span className="green fw-semibold small">{member.role}</span>
                      <p className="mt-2 text-muted small">
                        {member.desc}
                      </p>
                    </div>

                  </div>
                </div>
              ))}
            </div>
            <div className="section-bottom mt-5">
              <Link
                to="/team"
                className="btn btn-success px-5 py-3 rounded-pill fw-bold shadow-sm d-inline-flex align-items-center gap-2"
              >
                View Other Team Members
                <ArrowRight size={20} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;